import { noop } from 'lodash';
import { getIsCodeCheckMode } from './tools';
import { LogCollector } from './funcLogCollector';
Object.assign(window, { getIsCodeCheckMode });
let collector;
let done = noop;
let aiPageLoadReady = Promise.resolve();
// editor-entry 会侧效 import 本模块，保证下面这段在 Local/Remote 拆包之前执行。
if (getIsCodeCheckMode()) {
    collector = new LogCollector();
    const xyTool = {
        getLogMap: () => collector.getLogMap(),
        getVisitMap: () => collector.getVisitMap(),
    };
    aiPageLoadReady = new Promise(rs => done = rs);
    Object.assign(window, { aiPageLoadReady, xyTool });
}
export const interceptWujiIfNeeded = (obj, name) => {
    if (!getIsCodeCheckMode()) {
        return obj;
    }
    return collector.addIntercept(obj, name);
};
export function useSetupAICheck() {
    const markReady = (wait) => Promise.resolve(wait).finally(done);
    return {
        markReady,
    };
}
